<template>
    <div class="footer-wrapper">
        <div class="footer-menu-bar">
            <div class="menu-item"
                :class="{'active' : currentMenu == 'home'}"
                @click="gotoPage('home')">
                <div class="image" :class="{'actived' : currentMenu == 'home'}">
                    <img v-if="currentMenu != 'home'" src="@/assets/icon/footer/ic-gift-new-inactive.svg" />
                    <img v-if="currentMenu == 'home'" src="@/assets/icon/footer/ic-gift-new-active.svg" />
                </div>
                <div class="text" :class="{'actived' : currentMenu == 'home'}" >หน้าหลัก</div>
            </div>

            <div class="menu-item"
                :class="{'active' : currentMenu == 'point'}"
                @click="gotoPage('point')">
                <div class="image" :class="{'actived' : currentMenu == 'point'}">
                    <img v-if="currentMenu != 'point'" src="@/assets/icon/footer/ic-collect-new-inactive.svg" />
                    <img v-if="currentMenu == 'point'" src="@/assets/icon/footer/ic-collect-new-active.svg" />
                </div>
                <div class="text" :class="{'actived' : currentMenu == 'point'}" >สะสมพอยท์</div>
                <!-- <div class="line"></div> -->
            </div>

            <div class="menu-item"
                :class="{'active' : currentMenu == 'profile'}"
                @click="gotoPage('profile')" disabled>
                <div class="image" :class="{'actived' : currentMenu == 'profile'}">
                    <img v-if="currentMenu != 'profile'" src="@/assets/icon/footer/ic-profile-new-inactive.svg" />
                    <img v-if="currentMenu == 'profile'" src="@/assets/icon/footer/ic-profile-new-active.svg" />
                </div>
                <div class="text" :class="{'actived' : currentMenu == 'profile'}" >โปรไฟล์</div>
            </div>
        </div>
    </div>
</template>
<script>
import AccountMixin from "@/mixin/AccountMixin.js";
import LocaleMixin from "@/mixin/LocaleMixin.js";
import { TrackingService } from "@/helper/TrackingHelper.js";
export default {
    name: "FooterMenu",
    mixins: [AccountMixin, LocaleMixin],
    props:{
        currentMenu: String,
        controller: Object,
    },
    data: function() {
        return {
            tracking: new TrackingService(this)
        };
    },
    methods:{
        gotoPage:function(page){
            var newPath = '/' + page;
            var currentPath = this.$route.path;
            if(this.isLogin) {
                if (newPath != currentPath) {
                    this.$router.push(newPath);
                }
                switch (newPath){
                    case '/point' :
                        this.tracking.event('menu_collect_point', 'click_menu_collect_point');
                        break;
                    case '/mission' :
                        this.tracking.event('menu_mission', 'click_menu_mission');
                        break;
                }
            }else{
                if(page != 'home'){
                    var lbl_page = this.lbl.modalSkip;
                    var skip_title = '';
                    var skip_msg = '';

                    switch (page){
                        case 'point' :
                            skip_title = lbl_page.collect_points.title;
                            skip_msg = lbl_page.collect_points.msg;
                            break;
                        case 'mission' :
                            skip_title = lbl_page.mission.title;
                            skip_msg = lbl_page.mission.msg;
                            break;
                    }
                    this.controller.skipModal
                        .setTitle(skip_title)
                        .setMsg(skip_msg)
                        .setBtnOk(lbl_page.btn_confirm)
                        .setTag('skip-login')
                        .show();

                    this.controller.skipModal.onClickOk((data) =>{
                        if(data.tag == 'skip-login'){
                        window.location.replace('/linelogin');
                        }
                    });
                }else{
                    this.$router.push('/');
                }

            }
        }
    }
}
</script>
<style lang="scss" scoped>
@import "@/style/base/base.scss";
@import "@/style/base/baseDisplay.scss";
@import "./FooterMenu.scss"
</style>
